import { render, staticRenderFns } from "./editBpage.vue?vue&type=template&id=2999846b&scoped=true"
import script from "./editBpage.vue?vue&type=script&lang=js"
export * from "./editBpage.vue?vue&type=script&lang=js"
import style0 from "./editBpage.vue?vue&type=style&index=0&id=2999846b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2999846b",
  null
  
)

export default component.exports